var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { crossSvg, internalLinkSvg } from '../helpers/elements.js';
import { classMap } from 'lit/directives/class-map.js';
import { adminMessageShown$ } from '../stores/store-main.js';
import { SubscriptionsController } from '../helpers/SubscriptionsController.js';
let ElementTopNotification = class ElementTopNotification extends LitElement {
    constructor() {
        super(...arguments);
        this.show = true;
        this.text = '';
        this.subscriptionController = new SubscriptionsController(this, () => [
            adminMessageShown$.subscribe((show) => (this.show = show)),
        ]);
        this.handleResize = async () => {
            this.text = this.message?.text;
            await this.updateComplete;
            const p = document.getElementById('admin-message-paragraph');
            const container = document.getElementById('admin-message-text-container');
            this.defineTextToShow(p, container);
        };
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.handleResize);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        super.disconnectedCallback();
    }
    get bgFill() {
        switch (this.message.type) {
            case 'success':
                return 'bg-success';
            case 'warning':
                return 'bg-warning';
            case 'error':
                return 'bg-error';
            default:
                return 'bg-chm-light-gray';
        }
    }
    get icon() {
        switch (this.message.type) {
            case 'success':
                return 'bg-[url("./src/img/i_notification_ok.svg")]';
            case 'warning':
                return 'bg-[url("./src/img/i_notification_warning.svg")]';
            case 'error':
                return 'bg-[url("./src/img/i_notification_err.svg")]';
            default:
                return 'bg-[url("./src/img/i_notification_info.svg")]';
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('message') && this.message) {
            this.text = this.message.text;
            this.checkTextFitting();
        }
    }
    render() {
        if (!this.message || !this.show)
            return '';
        const py = 'py-[8px] sm:py-[13px] lg:py-[17px] xxl:py-[13px]';
        return html ` <div
      class="body h-top-message ${classMap({
            [this.bgFill]: true,
        })} relative z-50 flex justify-center"
    >
      <div class="top-msg-w-content flex items-center justify-center">
        <div class="top-msg-w-content flex max-h-full">
          <div class="pr-[8px] sm:pr-[12px] ${py}">
            <div class="flex items-center h-[22px] sm:h-[28px] xxl:h-[32px]">
              <div
                class="${classMap({
            [this.icon]: true,
        })} h-[24px] w-[24px] bg-cover bg-no-repeat"
              ></div>
            </div>
          </div>
          <div
            id="admin-message-text-container"
            class="flex grow flex-col ${py} sm:flex-row sm:gap-[12px] min-w-0 gap-y-[8px] relative"
          >
            <div
              id="admin-message-text"
              class="min-w-0 gap-x-[4px] sm:gap-x-[8px] banner-font max-h-full overflow-hidden"
            >
              <p id="admin-message-paragraph">
                <span
                  class="font-bold"
                  .hidden="${!this.message.title || !this.message.title.length}"
                >
                  ${this.message.title}
                </span>
                <span class="banner-text mr-[6px]"> ${this.text} </span>
                ${!this.message.urlLink?.length
            ? ''
            : this.renderLink(this.message.urlLink, this.message.urlText)}
              </p>
            </div>
          </div>
          <button
            class="cursor-pointer pl-[8px] sm:pl-[12px] flex ${py}"
            @click="${() => adminMessageShown$.next(false)}"
          >
            <div class="flex items-center h-[22px] sm:h-[28px] xxl:h-[32px]">
              ${crossSvg('h-[26px] w-[26px] -mt-[2px] fill-chm-red hover:fill-chm-focus-red')}
            </div>
          </button>
        </div>
      </div>
    </div>`;
    }
    renderLink(urlLink, urlText) {
        const internal = urlLink.startsWith('/');
        return html `
      <a
        href="${urlLink}"
        target="${internal ? '_self' : '_blank'}"
        rel="noopener"
        class="inline-flex items-center group hover:text-chm-focus-red link-with-icon-in-context"
      >
        <div class="w-0">&nbsp;</div>
        ${internalLinkSvg({
            classes: 'clickable-icon-in-group mr-[6px]',
        })}
        <span>${urlText}</span>
        ${!internal
            ? html `<span class="screen-reader-only"
                >(s\u2019ouvre dans un nouvel onglet)</span
              >` : ''}
      </a>
    `;
    }
    ellipseText(p, container, clone) {
        return new Promise((resolve) => {
            this.observer.disconnect();
            const availableLines = container.offsetHeight > 100 ? 4 : 2;
            const reductionStep = availableLines === 4 ? 3 : 7;
            const numberOfLines = Math.ceil((p.offsetHeight / container.offsetHeight) * availableLines);
            let reduced = this.text;
            const approxLineLenght = p.innerText.length / numberOfLines;
            const entireLinesToCut = numberOfLines - availableLines - 1;
            reduced = this.text.slice(0, this.text.length - approxLineLenght * entireLinesToCut);
            const reduceText = () => {
                reduced = reduced.slice(0, reduced.length - reductionStep);
                clone.querySelector('.banner-text').textContent = reduced + '...';
                if (clone.offsetHeight - (container.clientHeight - 20) > 10) {
                    requestAnimationFrame(reduceText);
                }
                else {
                    this.text = clone.querySelector('.banner-text').textContent;
                    resolve();
                }
            };
            reduceText();
        });
    }
    async checkTextFitting() {
        const p = document.getElementById('admin-message-paragraph');
        const container = document.getElementById('admin-message-text-container');
        if (container && p) {
            this.observer = new MutationObserver(() => {
                this.defineTextToShow(p, container);
            });
            this.observer.observe(p, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }
    }
    defineTextToShow(p, container) {
        const text = document.getElementById('admin-message-text');
        if (container && p) {
            if (p.offsetHeight - (container.clientHeight - 20) > 10) {
                const clone = p.cloneNode(true);
                clone.style.visibility = 'hidden';
                clone.style.position = 'absolute';
                text.appendChild(clone);
                this.ellipseText(p, container, clone).then(() => {
                    text.removeChild(clone);
                });
            }
            else {
                this.text = this.message.text;
            }
        }
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Object })
], ElementTopNotification.prototype, "message", void 0);
__decorate([
    state()
], ElementTopNotification.prototype, "show", void 0);
__decorate([
    state()
], ElementTopNotification.prototype, "text", void 0);
ElementTopNotification = __decorate([
    customElement('element-top-notification')
], ElementTopNotification);
export { ElementTopNotification };
//# sourceMappingURL=element-top-notification.js.map